/**
 * useGroups Hook
 *
 * React Query hook for fetching the list of groups for a tenant.
 */

import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { groupService } from '../../../api/group.service';
import type { GroupSanitized, GroupListQuery } from '../../../types/group.types';
import { getErrorMessage } from '../../../lib/utils/errors';

/**
 * Hook for fetching groups list
 */
export const useGroups = (
  tenantId: string,
  query?: GroupListQuery
): UseQueryResult<GroupSanitized[], Error> => {
  return useQuery<GroupSanitized[], Error>({
    queryKey: ['groups', tenantId, query],
    queryFn: async () => {
      console.log('[useGroups] Fetching groups for tenant:', tenantId);
      return await groupService.listGroups(tenantId, query);
    },
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    onError: (error) => {
      console.error('[useGroups] Failed to fetch groups:', getErrorMessage(error));
    },
  });
};
